import { render, staticRenderFns } from "./UserList.view.vue?vue&type=template&id=36c3dbca&"
import script from "./UserList.view.vue?vue&type=script&lang=js&"
export * from "./UserList.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports